import { Injectable, inject } from '@angular/core';
import { AuthLinksService } from './auth-links.service';
import { Subscription } from 'rxjs';
import { InAppBrowserService } from './in-app-browser.service';
import { OauthRedirectLoginGuard } from 'src/guards/oauth-redirect-login.guard';
import { NotificationService } from './notification.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class InAppBrowserAuthService {
  private authLinksService = inject(AuthLinksService);
  private browserService = inject(InAppBrowserService);
  private notificationService = inject(NotificationService);
  private translateService = inject(TranslateService);
  private oauthRedirectLoginGuard = inject(OauthRedirectLoginGuard);

  private urlChange$: null | Subscription = null;
  private browserClose$: null | Subscription = null;

  public openInAppBrowser(): void {
    this.browserService.open(this.authLinksService.bcasClientLoginUrl);

    if(!this.browserService.networkConnected) {
      this.browserService.close();
      this.notificationService.error(
        this.translateService.instant('toastNotifications.headers.error'),
        this.translateService.instant('toastNotifications.messages.browserLoginLoadError'),
      );
      return;
    }

    this.urlChange$ = this.browserService.onUrlChange().subscribe((navUrl) => {
      if (navUrl.startsWith(this.authLinksService.clientRedirectUri) || navUrl.startsWith(this.authLinksService.consultRedirectUri)) {
        this.handleLoginRedirect(navUrl);
        this.browserService.close();
        this.unsubBrowser();
      }
    });

    this.browserClose$ = this.browserService.onBrowserClose().subscribe(() => {
      this.unsubBrowser();
    });
  }

  private handleLoginRedirect(navUrl: string): void {
    // todo: something more standardized
    const pathWithToken = navUrl.replace(this.authLinksService.clientRedirectUri , '').replace('?', '');
    const bcasUrlTokens = pathWithToken.split('&');

    for (const parameter of bcasUrlTokens) {
      const [key, value] = parameter.split('=');

      if(key === 'code') {
        this.oauthRedirectLoginGuard.inAppBrowserAssignKeyAndNavigate(value);
      }
    }
  }

  private unsubBrowser(): void {
    this.browserClose$?.unsubscribe();
    this.urlChange$?.unsubscribe();
    this.browserClose$ = null;
    this.urlChange$ = null;
  }

}
